import React, { useEffect, useState } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import '../Produto/index.css';
import logo from '../../imagens/Sem fundo.png';
import { Checkbox } from '@mui/material';

const Cliente = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();  

  const [loadingProdutos, setLoadingProdutos] = useState(true)
  const [produtos, setProdutos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [expandedProdutoId, setExpandedProdutoId] = useState(null);
  const [produtoComprado, setProdutoComprado] = useState(false);
  const [produtoEmEstoque, setProdutoEmEstoque] = useState(false);

  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  useEffect(() => {
  const fetchProduto = async () => {
    // Se não estiver logado, evita execução
    if (!userInfo?.url || !userInfo?.alias || !userInfo?.venLogin || !userInfo?.venSenha) {
      return;
    }

    try {
      setLoadingProdutos(true);

      const res = await fetch(`${userInfo.url}/produto/WenAPP`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();

      try {
        const json = JSON.parse(text);
        setProdutos(json);
      } catch (e) {
        console.error("❌ Erro ao converter PRODUTO para JSON:", e);
        throw new Error("Resposta não é JSON");
      }
    } catch (err) {
      console.error('Erro ao buscar PRODUTOS:', err);
    } finally {
      setLoadingProdutos(false);
    }
  };

    fetchProduto();
  }, [userInfo, credentials]);

  const filteredProdutos = produtos.filter((p) => {
    const termo = searchTerm.toLowerCase();
    const matchesSearch = 
      p.proDescricao?.toLowerCase().includes(termo) ||
      p.proCodInterno?.toLowerCase().includes(termo);

    const matchesComprado = !produtoComprado || (p.qtdComprado > 0);
    const matchesEstoque = !produtoEmEstoque || (p.proQtdEstoque > 0);

    return matchesSearch && matchesComprado && matchesEstoque;
  });

  const handleSelectProduto = (produto) => {
    setSelectedProduto(produto);
    setSearchTerm(produto.proDescricao);
    setShowSuggestions(false);
  };

  const toggleExpand = (id) => {
    setExpandedProdutoId(prevId => (prevId === id ? null : id));
  };

  return (
      <>
    {loadingProdutos ? (
       <div className="loading-container" tabIndex={-1}>
        <img src={logo} alt="Logo" className="loading-logo" />
        <p>Carregando Produtos...</p>
      </div>
    ) : (
    <>
      <header className="header">
        <img src={`${userInfo.url}/imagens/${userInfo.alias}.bmp`} alt="Logo da empresa"  className='logoHeader'></img>
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h1>Lista de Produtos {userInfo.company}</h1>
      </header>

      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      {/* 🔎 Filtro */}
      <div className="produto-box">
        <input
          type="text"
          placeholder="Pesquisar Produtos..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowSuggestions(true);
            setSelectedProduto(null);
          }}
          onFocus={() => setShowSuggestions(true)}
        />

        {selectedProduto && (
          <div className="produto-selecionado">
            <h3>Produto Selecionado:</h3>
            <p><strong>{selectedProduto.proDescricao}</strong></p>
          </div>
        )}

        {searchTerm && (
          <button
            className="btn-limpar"
            onClick={() => {
              setSearchTerm('');
              setSelectedProduto(null);
              setShowSuggestions(false);
            }}
          >
            Limpar
          </button>
        )}

        {showSuggestions && searchTerm && (
          <ul className="produto-list">
            {filteredProdutos.length > 0 ? (
              filteredProdutos.map((p, index) => (
                <li key={`${p.proId}-${index}`} onClick={() => handleSelectProduto(p)}>
                  {p.proDescricao}
                </li>
              ))
            ) : (
              <li>❌ Nenhum Produto encontrado</li>
            )}
          </ul>
        )}
        <div className="flegs">
          <div>
            <Checkbox checked={produtoComprado} onChange={(e) => setProdutoComprado(e.target.checked)} />
            <span><strong>Comprado, aguardando entrega</strong></span>
          </div>
          <div>
            <Checkbox checked={produtoEmEstoque} onChange={(e) => setProdutoEmEstoque(e.target.checked)} />
            <span><strong>Em Estoque</strong></span>
          </div>
        </div>
      </div>

      {/* 🧾 Lista de produto em Blocos */}
      <div className="produto-container-Cadastro">
        {filteredProdutos.map((produto) => {
          const isExpanded = expandedProdutoId === produto.proId;

          return (
            <div key={produto.proId} className="produto-card-cadastro">
              <div className={`cabProduto ${produto.proQtdEstoque < 0.01 ? 'estoque-baixo' : ''}`}>
                <span><strong>ID:</strong> {produto.proCodInterno}</span>
                <span><strong>Descrição:</strong> {produto.proDescricao}</span>
                <span>
                  📦 Estoque:{" "}
                  {produto.proQtdEstoque != null
                    ? produto.proQtdEstoque.toLocaleString("pt-BR", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })
                    : "0,000"}{" "}
                  {produto.embUnidade}
                </span>

                <button
                  className="expand-button"
                  onClick={() => toggleExpand(produto.proId)}
                >
                  {isExpanded ? '−' : '+'}
                </button>
              </div>

              {isExpanded && (
                <>
                  <div className='ifonProdImport'>
                    <span>
                      <strong>Comprado, aguardando entrega: </strong>{" "}
                  {produto.qtdComprado != null
                    ? produto.qtdComprado.toLocaleString("pt-BR", {
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3,
                      })
                    : "0,000"}{" "}
                    </span>
                    <span><strong>Valor de Venda:</strong> {produto.proVlrVenda?.toFixed(2)}</span>
                  </div>
                  <span><strong>Percentual de Comissão:</strong> {produto.proPerComissao?.toFixed(2)}%</span>
                  <span><strong>Marca:</strong> {produto.marDescricao}</span>
                  <span><strong>Embalagem:</strong> {produto.embDescricao} - {produto.embUnidade}</span>
                  <span><strong>Código de Barras:</strong> {produto.proCodBarras}</span>
                  <span><strong>Referência:</strong> {produto.proReferencia}</span>
                  <p><b>Grupo:</b> {produto.gruDescricao || '-'}</p>
                  <p><b>SubGrupo:</b> {produto.subDescricao || '-'}</p>
                </>
              )}
            </div>
          );
        })}
      </div>
    </>
    )}
  </>    
  );
};

export default Cliente;